// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc, DisplayNamedFragmentDoc } from '../../../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type MakeNewDesignPackageMutationVariables = Types.Exact<{
  input: Types.SaveDesignPackageInput;
}>;


export type MakeNewDesignPackageMutation = { __typename?: 'Mutation', saveDesignPackage: { __typename?: 'SaveDesignPackageResult', designPackage: { __typename?: 'DesignPackage', id: string, copyInProgress: boolean, version: { __typename?: 'ReadyPlanAggregateVersion', id: string } } } };

export type NewDesignPackagePlanPackagesQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.PlanPackageFilter>;
}>;


export type NewDesignPackagePlanPackagesQuery = { __typename?: 'Query', planPackages: { __typename?: 'PlanPackagesPageResult', entities: Array<{ __typename?: 'PlanPackage', id: string, name: string, code?: string | null | undefined, status: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus } }> } };

export type NewDesignPackage_GlobalOptionGroupsQueryVariables = Types.Exact<{
  designPackageId: Types.Scalars['ID']['input'];
  includeScopedGroups: Types.Scalars['Boolean']['input'];
  forInterior?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  forExterior?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type NewDesignPackage_GlobalOptionGroupsQuery = { __typename?: 'Query', scopedGroups?: Array<{ __typename?: 'GlobalOptionGroup', id: string, name: string, forDesignInterior: boolean, forDesignExterior: boolean, type: { __typename?: 'GlobalOptionType', id: string, name: string, order: number, isSpecLevel: boolean, isElevation: boolean, isExteriorScheme: boolean, isInteriorScheme: boolean }, globalOptions: Array<{ __typename?: 'GlobalOption', id: string, name: string, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string } } }> }>, sharedGroups: Array<{ __typename?: 'GlobalOptionGroup', id: string, name: string, forDesignInterior: boolean, forDesignExterior: boolean, type: { __typename?: 'GlobalOptionType', id: string, name: string, order: number, isSpecLevel: boolean, isElevation: boolean, isExteriorScheme: boolean, isInteriorScheme: boolean }, globalOptions: Array<{ __typename?: 'GlobalOption', id: string, name: string, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string } } }> }>, types: Array<{ __typename?: 'GlobalOptionType', id: string, name: string, order: number, isExteriorScheme: boolean, isInteriorScheme: boolean }> };

export type EditDesignPackageQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  versionId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type EditDesignPackageQuery = { __typename?: 'Query', designPackage: { __typename?: 'DesignPackage', id: string, name: string, location: { __typename?: 'DesignPackageLocationDetail', code: Types.DesignPackageLocation }, planPackages: Array<{ __typename?: 'PlanPackage', id: string }>, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, active: boolean, createdAt: Types.Scalars['DateTime']['input'], globalOption: { __typename?: 'GlobalOption', id: string, name: string, group: { __typename?: 'GlobalOptionGroup', id: string, name: string, forDesignInterior: boolean, forDesignExterior: boolean, type: { __typename?: 'GlobalOptionType', id: string, name: string, order: number, isSpecLevel: boolean, isElevation: boolean, isExteriorScheme: boolean, isInteriorScheme: boolean }, globalOptions: Array<{ __typename?: 'GlobalOption', id: string, name: string, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string } } }> } }, optionPrereqChildren: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, active: boolean, globalOption: { __typename?: 'GlobalOption', id: string, name: string, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string } } } }> }>, markets: Array<{ __typename?: 'Market', id: string, name: string }>, owner?: { __typename?: 'InternalUser', id: string } | null | undefined } };

export type EditDesignPackage_DesignPackageFragment = { __typename?: 'DesignPackage', id: string, name: string, location: { __typename?: 'DesignPackageLocationDetail', code: Types.DesignPackageLocation }, planPackages: Array<{ __typename?: 'PlanPackage', id: string }>, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, active: boolean, createdAt: Types.Scalars['DateTime']['input'], globalOption: { __typename?: 'GlobalOption', id: string, name: string, group: { __typename?: 'GlobalOptionGroup', id: string, name: string, forDesignInterior: boolean, forDesignExterior: boolean, type: { __typename?: 'GlobalOptionType', id: string, name: string, order: number, isSpecLevel: boolean, isElevation: boolean, isExteriorScheme: boolean, isInteriorScheme: boolean }, globalOptions: Array<{ __typename?: 'GlobalOption', id: string, name: string, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string } } }> } }, optionPrereqChildren: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, active: boolean, globalOption: { __typename?: 'GlobalOption', id: string, name: string, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string } } } }> }>, markets: Array<{ __typename?: 'Market', id: string, name: string }>, owner?: { __typename?: 'InternalUser', id: string } | null | undefined };

export type PreselectOptionsFromPlanPackagesQueryVariables = Types.Exact<{
  planPackageIds: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
}>;


export type PreselectOptionsFromPlanPackagesQuery = { __typename?: 'Query', planPackages: { __typename?: 'PlanPackagesPageResult', entities: Array<{ __typename?: 'PlanPackage', id: string, optionGroups: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string, isElevation: boolean } }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, active: boolean, createdAt: Types.Scalars['DateTime']['input'], globalOption: { __typename?: 'GlobalOption', id: string, name: string, group: { __typename?: 'GlobalOptionGroup', id: string, name: string, forDesignInterior: boolean, forDesignExterior: boolean, type: { __typename?: 'GlobalOptionType', id: string, name: string, order: number, isSpecLevel: boolean, isElevation: boolean, isExteriorScheme: boolean, isInteriorScheme: boolean }, globalOptions: Array<{ __typename?: 'GlobalOption', id: string, name: string, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string } } }> } }, optionPrereqChildren: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, active: boolean, globalOption: { __typename?: 'GlobalOption', id: string, name: string, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string } } } }> }> }> }> } };

export type NewDesignPackage_ReadyPlanOptionFragment = { __typename?: 'ReadyPlanOption', id: string, name: string, active: boolean, createdAt: Types.Scalars['DateTime']['input'], globalOption: { __typename?: 'GlobalOption', id: string, name: string, group: { __typename?: 'GlobalOptionGroup', id: string, name: string, forDesignInterior: boolean, forDesignExterior: boolean, type: { __typename?: 'GlobalOptionType', id: string, name: string, order: number, isSpecLevel: boolean, isElevation: boolean, isExteriorScheme: boolean, isInteriorScheme: boolean }, globalOptions: Array<{ __typename?: 'GlobalOption', id: string, name: string, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string } } }> } }, optionPrereqChildren: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, active: boolean, globalOption: { __typename?: 'GlobalOption', id: string, name: string, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string } } } }> };

export type NewDesignPackage_GlobalOptionGroupFragment = { __typename?: 'GlobalOptionGroup', id: string, name: string, forDesignInterior: boolean, forDesignExterior: boolean, type: { __typename?: 'GlobalOptionType', id: string, name: string, order: number, isSpecLevel: boolean, isElevation: boolean, isExteriorScheme: boolean, isInteriorScheme: boolean }, globalOptions: Array<{ __typename?: 'GlobalOption', id: string, name: string, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string } } }> };

export type NewDesignPackage_GlobalOptionTypeFragment = { __typename?: 'GlobalOptionType', id: string, name: string, order: number, isExteriorScheme: boolean, isInteriorScheme: boolean };

export type NewDesignPackage_GlobalOptionFragment = { __typename?: 'GlobalOption', id: string, name: string, group: { __typename?: 'GlobalOptionGroup', id: string, type: { __typename?: 'GlobalOptionType', id: string } } };

export const NewDesignPackage_GlobalOptionFragmentDoc = gql`
    fragment NewDesignPackage_GlobalOption on GlobalOption {
  id
  name
  group {
    id
    type {
      id
    }
  }
}
    `;
export const NewDesignPackage_GlobalOptionGroupFragmentDoc = gql`
    fragment NewDesignPackage_GlobalOptionGroup on GlobalOptionGroup {
  id
  name
  forDesignInterior
  forDesignExterior
  type {
    id
    name
    order
    isSpecLevel
    isElevation
    isExteriorScheme
    isInteriorScheme
  }
  globalOptions {
    ...NewDesignPackage_GlobalOption
  }
}
    ${NewDesignPackage_GlobalOptionFragmentDoc}`;
export const NewDesignPackage_ReadyPlanOptionFragmentDoc = gql`
    fragment NewDesignPackage_ReadyPlanOption on ReadyPlanOption {
  id
  name
  active
  globalOption {
    id
    name
    group {
      ...NewDesignPackage_GlobalOptionGroup
    }
  }
  createdAt
  optionPrereqChildren {
    id
    name
    active
    globalOption {
      ...NewDesignPackage_GlobalOption
    }
  }
}
    ${NewDesignPackage_GlobalOptionGroupFragmentDoc}
${NewDesignPackage_GlobalOptionFragmentDoc}`;
export const EditDesignPackage_DesignPackageFragmentDoc = gql`
    fragment EditDesignPackage_DesignPackage on DesignPackage {
  id
  name
  location {
    code
  }
  planPackages {
    id
  }
  options {
    ...NewDesignPackage_ReadyPlanOption
  }
  markets {
    ...Named
  }
  owner {
    id
  }
}
    ${NewDesignPackage_ReadyPlanOptionFragmentDoc}
${NamedFragmentDoc}`;
export const NewDesignPackage_GlobalOptionTypeFragmentDoc = gql`
    fragment NewDesignPackage_GlobalOptionType on GlobalOptionType {
  id
  name
  order
  isExteriorScheme
  isInteriorScheme
}
    `;
export const MakeNewDesignPackageDocument = gql`
    mutation MakeNewDesignPackage($input: SaveDesignPackageInput!) {
  saveDesignPackage(input: $input) {
    designPackage {
      id
      version {
        id
      }
      copyInProgress
    }
  }
}
    `;
export type MakeNewDesignPackageMutationFn = Apollo.MutationFunction<MakeNewDesignPackageMutation, MakeNewDesignPackageMutationVariables>;

/**
 * __useMakeNewDesignPackageMutation__
 *
 * To run a mutation, you first call `useMakeNewDesignPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeNewDesignPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeNewDesignPackageMutation, { data, loading, error }] = useMakeNewDesignPackageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMakeNewDesignPackageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MakeNewDesignPackageMutation, MakeNewDesignPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MakeNewDesignPackageMutation, MakeNewDesignPackageMutationVariables>(MakeNewDesignPackageDocument, options);
      }
export type MakeNewDesignPackageMutationHookResult = ReturnType<typeof useMakeNewDesignPackageMutation>;
export type MakeNewDesignPackageMutationResult = Apollo.MutationResult<MakeNewDesignPackageMutation>;
export type MakeNewDesignPackageMutationOptions = Apollo.BaseMutationOptions<MakeNewDesignPackageMutation, MakeNewDesignPackageMutationVariables>;
export const NewDesignPackagePlanPackagesDocument = gql`
    query NewDesignPackagePlanPackages($filter: PlanPackageFilter) {
  planPackages(filter: $filter) {
    entities {
      id
      name
      code
      status {
        code
      }
    }
  }
}
    `;

/**
 * __useNewDesignPackagePlanPackagesQuery__
 *
 * To run a query within a React component, call `useNewDesignPackagePlanPackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewDesignPackagePlanPackagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewDesignPackagePlanPackagesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useNewDesignPackagePlanPackagesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<NewDesignPackagePlanPackagesQuery, NewDesignPackagePlanPackagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<NewDesignPackagePlanPackagesQuery, NewDesignPackagePlanPackagesQueryVariables>(NewDesignPackagePlanPackagesDocument, options);
      }
export function useNewDesignPackagePlanPackagesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<NewDesignPackagePlanPackagesQuery, NewDesignPackagePlanPackagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<NewDesignPackagePlanPackagesQuery, NewDesignPackagePlanPackagesQueryVariables>(NewDesignPackagePlanPackagesDocument, options);
        }
export function useNewDesignPackagePlanPackagesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<NewDesignPackagePlanPackagesQuery, NewDesignPackagePlanPackagesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<NewDesignPackagePlanPackagesQuery, NewDesignPackagePlanPackagesQueryVariables>(NewDesignPackagePlanPackagesDocument, options);
        }
export type NewDesignPackagePlanPackagesQueryHookResult = ReturnType<typeof useNewDesignPackagePlanPackagesQuery>;
export type NewDesignPackagePlanPackagesLazyQueryHookResult = ReturnType<typeof useNewDesignPackagePlanPackagesLazyQuery>;
export type NewDesignPackagePlanPackagesSuspenseQueryHookResult = ReturnType<typeof useNewDesignPackagePlanPackagesSuspenseQuery>;
export type NewDesignPackagePlanPackagesQueryResult = Apollo.QueryResult<NewDesignPackagePlanPackagesQuery, NewDesignPackagePlanPackagesQueryVariables>;
export const NewDesignPackage_GlobalOptionGroupsDocument = gql`
    query NewDesignPackage_GlobalOptionGroups($designPackageId: ID!, $includeScopedGroups: Boolean!, $forInterior: Boolean, $forExterior: Boolean) {
  scopedGroups: globalOptionGroups(
    filter: {version: [2], readyPlan: [$designPackageId], forDesignInterior: $forInterior, forDesignExterior: $forExterior}
  ) @include(if: $includeScopedGroups) {
    ...NewDesignPackage_GlobalOptionGroup
  }
  sharedGroups: globalOptionGroups(
    filter: {version: [2], readyPlan: null, forDesignInterior: $forInterior, forDesignExterior: $forExterior}
  ) {
    ...NewDesignPackage_GlobalOptionGroup
  }
  types: globalOptionTypes(
    filter: {version: [2], isInteriorScheme: $forInterior, isExteriorScheme: $forExterior}
  ) {
    ...NewDesignPackage_GlobalOptionType
  }
}
    ${NewDesignPackage_GlobalOptionGroupFragmentDoc}
${NewDesignPackage_GlobalOptionTypeFragmentDoc}`;

/**
 * __useNewDesignPackage_GlobalOptionGroupsQuery__
 *
 * To run a query within a React component, call `useNewDesignPackage_GlobalOptionGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewDesignPackage_GlobalOptionGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewDesignPackage_GlobalOptionGroupsQuery({
 *   variables: {
 *      designPackageId: // value for 'designPackageId'
 *      includeScopedGroups: // value for 'includeScopedGroups'
 *      forInterior: // value for 'forInterior'
 *      forExterior: // value for 'forExterior'
 *   },
 * });
 */
export function useNewDesignPackage_GlobalOptionGroupsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<NewDesignPackage_GlobalOptionGroupsQuery, NewDesignPackage_GlobalOptionGroupsQueryVariables> & ({ variables: NewDesignPackage_GlobalOptionGroupsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<NewDesignPackage_GlobalOptionGroupsQuery, NewDesignPackage_GlobalOptionGroupsQueryVariables>(NewDesignPackage_GlobalOptionGroupsDocument, options);
      }
export function useNewDesignPackage_GlobalOptionGroupsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<NewDesignPackage_GlobalOptionGroupsQuery, NewDesignPackage_GlobalOptionGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<NewDesignPackage_GlobalOptionGroupsQuery, NewDesignPackage_GlobalOptionGroupsQueryVariables>(NewDesignPackage_GlobalOptionGroupsDocument, options);
        }
export function useNewDesignPackage_GlobalOptionGroupsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<NewDesignPackage_GlobalOptionGroupsQuery, NewDesignPackage_GlobalOptionGroupsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<NewDesignPackage_GlobalOptionGroupsQuery, NewDesignPackage_GlobalOptionGroupsQueryVariables>(NewDesignPackage_GlobalOptionGroupsDocument, options);
        }
export type NewDesignPackage_GlobalOptionGroupsQueryHookResult = ReturnType<typeof useNewDesignPackage_GlobalOptionGroupsQuery>;
export type NewDesignPackage_GlobalOptionGroupsLazyQueryHookResult = ReturnType<typeof useNewDesignPackage_GlobalOptionGroupsLazyQuery>;
export type NewDesignPackage_GlobalOptionGroupsSuspenseQueryHookResult = ReturnType<typeof useNewDesignPackage_GlobalOptionGroupsSuspenseQuery>;
export type NewDesignPackage_GlobalOptionGroupsQueryResult = Apollo.QueryResult<NewDesignPackage_GlobalOptionGroupsQuery, NewDesignPackage_GlobalOptionGroupsQueryVariables>;
export const EditDesignPackageDocument = gql`
    query EditDesignPackage($id: ID!, $versionId: ID) {
  designPackage(id: $id, versionId: $versionId) {
    ...EditDesignPackage_DesignPackage
  }
}
    ${EditDesignPackage_DesignPackageFragmentDoc}`;

/**
 * __useEditDesignPackageQuery__
 *
 * To run a query within a React component, call `useEditDesignPackageQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditDesignPackageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditDesignPackageQuery({
 *   variables: {
 *      id: // value for 'id'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useEditDesignPackageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EditDesignPackageQuery, EditDesignPackageQueryVariables> & ({ variables: EditDesignPackageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EditDesignPackageQuery, EditDesignPackageQueryVariables>(EditDesignPackageDocument, options);
      }
export function useEditDesignPackageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EditDesignPackageQuery, EditDesignPackageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EditDesignPackageQuery, EditDesignPackageQueryVariables>(EditDesignPackageDocument, options);
        }
export function useEditDesignPackageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EditDesignPackageQuery, EditDesignPackageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EditDesignPackageQuery, EditDesignPackageQueryVariables>(EditDesignPackageDocument, options);
        }
export type EditDesignPackageQueryHookResult = ReturnType<typeof useEditDesignPackageQuery>;
export type EditDesignPackageLazyQueryHookResult = ReturnType<typeof useEditDesignPackageLazyQuery>;
export type EditDesignPackageSuspenseQueryHookResult = ReturnType<typeof useEditDesignPackageSuspenseQuery>;
export type EditDesignPackageQueryResult = Apollo.QueryResult<EditDesignPackageQuery, EditDesignPackageQueryVariables>;
export const PreselectOptionsFromPlanPackagesDocument = gql`
    query PreselectOptionsFromPlanPackages($planPackageIds: [ID!]!) {
  planPackages(filter: {ids: $planPackageIds}) {
    entities {
      id
      optionGroups {
        id
        group {
          id
          type {
            id
            isElevation
          }
        }
        options {
          ...NewDesignPackage_ReadyPlanOption
        }
      }
    }
  }
}
    ${NewDesignPackage_ReadyPlanOptionFragmentDoc}`;

/**
 * __usePreselectOptionsFromPlanPackagesQuery__
 *
 * To run a query within a React component, call `usePreselectOptionsFromPlanPackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreselectOptionsFromPlanPackagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreselectOptionsFromPlanPackagesQuery({
 *   variables: {
 *      planPackageIds: // value for 'planPackageIds'
 *   },
 * });
 */
export function usePreselectOptionsFromPlanPackagesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PreselectOptionsFromPlanPackagesQuery, PreselectOptionsFromPlanPackagesQueryVariables> & ({ variables: PreselectOptionsFromPlanPackagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PreselectOptionsFromPlanPackagesQuery, PreselectOptionsFromPlanPackagesQueryVariables>(PreselectOptionsFromPlanPackagesDocument, options);
      }
export function usePreselectOptionsFromPlanPackagesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PreselectOptionsFromPlanPackagesQuery, PreselectOptionsFromPlanPackagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PreselectOptionsFromPlanPackagesQuery, PreselectOptionsFromPlanPackagesQueryVariables>(PreselectOptionsFromPlanPackagesDocument, options);
        }
export function usePreselectOptionsFromPlanPackagesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PreselectOptionsFromPlanPackagesQuery, PreselectOptionsFromPlanPackagesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PreselectOptionsFromPlanPackagesQuery, PreselectOptionsFromPlanPackagesQueryVariables>(PreselectOptionsFromPlanPackagesDocument, options);
        }
export type PreselectOptionsFromPlanPackagesQueryHookResult = ReturnType<typeof usePreselectOptionsFromPlanPackagesQuery>;
export type PreselectOptionsFromPlanPackagesLazyQueryHookResult = ReturnType<typeof usePreselectOptionsFromPlanPackagesLazyQuery>;
export type PreselectOptionsFromPlanPackagesSuspenseQueryHookResult = ReturnType<typeof usePreselectOptionsFromPlanPackagesSuspenseQuery>;
export type PreselectOptionsFromPlanPackagesQueryResult = Apollo.QueryResult<PreselectOptionsFromPlanPackagesQuery, PreselectOptionsFromPlanPackagesQueryVariables>;